/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import ArchiveLocationForm from './ArchiveLocationForm/ArchiveLocationForm';
import ArchiveLocationSuccess from './ArchiveLocationSuccess/ArchiveLocationSuccess';
import ArchiveLocationError from './ArchiveLocationError/ArchiveLocationError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  location: Object,
  accountStore: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class ArchiveLocation extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore, accountStore, location }: TypeProps = this.props;

    const fields: Array<Object> = [
      {
        name: 'archiveReason',
        label: t('general:locations.reasons.why_archive'),
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_archiving_location'),
            rules: 'required|string',
            value: '',
            placeholder: 'Select a reason',
            extra: {
              options: [
                {
                  id: '1',
                  label: t('general:reasons.options.location_no_longer_exists'),
                },
                {
                  id: 'other',
                  label: t('general:reasons.options.other'),
                },
              ],
            },
          },
        ],
      },
    ];

    const hooks: Object = {
      onInit(data: Object) {
        location.hierarchy || accountStore.loadLocationDetails(location.id);
      },
      onSuccess(data: Object) {
        const { reason }: Object = data.values().archiveReason;

        actionDrawerStore.archiveLocation(location.id, {
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'archiveLocation',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore, location, type }: TypeProps = this.props;

    const title: string = t('general:actions.archive_location');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <ArchiveLocationError location={location} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <ArchiveLocationSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <ArchiveLocationForm location={location} form={this.createForm()} />
      </div>
    );
  }
}
